<div class="sma-container">
  <div class="header-section">
    <h3>{{ "SMA Options" | translate }}</h3>
    <button mat-raised-button color="primary" (click)="addSma()">
      <mat-icon>add</mat-icon>
      {{ "Add SMA" | translate }}
    </button>
  </div>

  <div class="table-wrapper">
    <table class="sma-table mat-elevation-z2">
      <thead>
        <tr>
          <th>{{ "Start Date" | translate }}</th>
          <th>{{ "End Date" | translate }}</th>
          <th>{{ "Actions" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sma of dataSource; trackBy: trackBySma">
          <td>{{ sma.start_date | date:'dd.MM.yyyy' }}</td>
          <td>{{ sma.end_date | date:'dd.MM.yyyy' }}</td>
          <td class="actions-cell">
            <button mat-icon-button (click)="editSma(sma)" [title]="'Edit' | translate">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="deleteSma(sma)" [title]="'Delete' | translate">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="dataSource.length === 0" class="no-data">
    {{ "No SMA options available" | translate }}
  </div>
</div>

